import { useState, useEffect } from "react";
import { Education } from "@/types/jobPost";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";

export const useEducations = () => {
  const [educations, setEducations] = useState<Education[] | null>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEducations = async () => {
      try {
        const response = await axiosInstance.get("jobs/educations/");

        setEducations(response.data);
      } catch (err) {
        if (isAxiosError(err)) {
          setError(err.message);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchEducations();
  }, []);

  return { educations, loading, error };
};
